import { useToast as useToastFromProvider } from '../components/ToastNotification';

// Re-export the useToast hook from ToastNotification
export const useToast = useToastFromProvider;
